// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBX4qL7lnaxu9F0K84V_3fEmRFzPk9rM54",
  authDomain: "smart-grin-365021.firebaseapp.com",
  projectId: "smart-grin-365021",
  storageBucket: "smart-grin-365021.firebasestorage.app",
  messagingSenderId: "1011935147861",
  appId: "1:1011935147861:web:d0cd64c8a22ba54879e1dc",
  measurementId: "G-RXECHFE8XL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
